export const CLEAR_CACHE_BUTTON_TITLE =
  "Limpia las imágenes, archivos y cookies de este sitio y luego recarga la página. Usá esta opción si ves información desactualizada, estilos que no se muestran correctamente o errores luego de una actualización. No se cerrará tu sesión.";

function clearOriginCookies() {
  if (typeof document === "undefined") return;

  const cookieNames = document.cookie
    .split(";")
    .map((cookie) => cookie.split("=")[0]?.trim())
    .filter(Boolean);

  const hostname = window.location.hostname;
  const domains = [hostname, `.${hostname}`];
  const paths = ["/", window.location.pathname];
  const expired = "expires=Thu, 01 Jan 1970 00:00:00 GMT";

  cookieNames.forEach((name) => {
    document.cookie = `${name}=; ${expired}; path=/`;
    paths.forEach((path) => {
      document.cookie = `${name}=; ${expired}; path=${path}`;
      domains.forEach((domain) => {
        document.cookie = `${name}=; ${expired}; path=${path}; domain=${domain}`;
      });
    });
  });
}

async function clearCacheStorage() {
  if (!("caches" in window)) return;
  const keys = await caches.keys();
  await Promise.all(keys.map((key) => caches.delete(key)));
}

async function unregisterServiceWorkers() {
  if (!("serviceWorker" in navigator)) return;
  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(registrations.map((registration) => registration.unregister()));
}

export async function clearSiteCacheAndReload() {
  try {
    await Promise.all([clearCacheStorage(), unregisterServiceWorkers()]);
    clearOriginCookies();
    await fetch(window.location.href, {
      cache: "reload",
      credentials: "same-origin",
    }).catch(() => undefined);
  } finally {
    window.location.reload();
  }
}
